import { DeleteOutlined } from '@ant-design/icons'
import { useMutation } from '@apollo/client'
import { Button, Col, Form, message, Modal, Row, Spin, Typography } from 'antd'
import * as PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import DELETE_LEAD_STAGE from '@dentolize/clinic-mobile/src/shared/store/mutations/actions/leads/deleteLeadStage'
import { useLoginModal } from '../../../../../context/loginModalContext'
import { showAuthError } from '../../../../../shared/utils/webHelpers'
import SearchField from '../../../../common/searchFields/SearchField'
import SEARCH_LEAD_STAGES from '@dentolize/clinic-mobile/src/shared/store/queries/actions/leads/searchLeadStages'

const DeleteLeadStageButton = ({ selectedItem, handleAnimateRow, handleClose }) => {
  const [visible, setVisible] = useState(false)

  const { leadStage } = useParams()
  const [form] = Form.useForm()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { setLoginModalVisible } = useLoginModal()

  const [deleteItem, { loading }] = useMutation(DELETE_LEAD_STAGE, {
    update: handleUpdateAfterDelete
  })

  function handleUpdateAfterDelete(store) {
    store.data.delete(`LeadStage:${selectedItem.id}`)
    handleAnimateRow && handleAnimateRow(null, true)
  }

  const { validateFields, scrollToField, resetFields } = form

  useEffect(() => {
    resetFields()
  }, [visible])

  const toggleVisible = () => setVisible(visible => !visible)

  const handleSubmit = () =>
    validateFields()
      .then(async values => {
        try {
          if (selectedItem.id === values.mergeTo.key) {
            message.error(t('app.mergeError'))
            return
          }
          await deleteItem({
            variables: {
              leadStage: selectedItem.id,
              mergeTo: values.mergeTo.key
            }
          })
          leadStage && navigate(-1)
          handleClose && handleClose()
          message.success(t('common.deletedSuccess'))
          toggleVisible()
        } catch (e) {
          showAuthError(e, t, setLoginModalVisible)
        }
      })
      .catch(({ errorFields }) => {
        scrollToField(errorFields?.[0]?.name)
      })

  return (
    <>
      <Modal
        open={visible}
        title={t('common.delete')}
        okButtonProps={{
          loading,
          htmlType: 'submit',
          form: 'DeleteLeadStageForm',
          'data-testid': 'leadStageForm-delete-confirm'
        }}
        onCancel={toggleVisible}
      >
        <Spin spinning={loading}>
          <Typography.Text type="danger" strong>
            {t('app.mergePatientAlert', {
              val: selectedItem.name
            })}
          </Typography.Text>
          <br />
          <br />
          <Form onFinish={handleSubmit} form={form} name="DeleteLeadStageForm" layout="vertical" scrollToFirstError>
            <Row type="flex" gutter={16}>
              <Col span={24}>
                <SearchField
                  GET_QUERY={SEARCH_LEAD_STAGES}
                  label={t('patients.newItem')}
                  fieldName="mergeTo"
                  dataName="searchLeadStages"
                  rules={[{ required: true, message: t('app.fieldRequired') }]}
                />
              </Col>
            </Row>
          </Form>
        </Spin>
      </Modal>
      <Button type="primary" danger onClick={toggleVisible} icon={<DeleteOutlined />} data-testid="LeadStageForm-delete">
        {t('common.delete')}
      </Button>
    </>
  )
}

DeleteLeadStageButton.propTypes = {
  selectedItem: PropTypes.object.isRequired,
  handleAnimateRow: PropTypes.func
}

export default DeleteLeadStageButton
